import axios, { AxiosInstance, AxiosError } from 'axios'
import i18next from 'i18next'

// Базовый URL API
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.verrafied.ai/api/v1'

// Создаем экземпляр axios с базовой конфигурацией
const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

apiClient.interceptors.request.use((config) => {
  config.headers['Accept-Language'] = i18next.language || 'en'
  return config
})

// Интерцептор для обработки ошибок
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Обработка ошибок API
    if (error.response) {
      // Сервер вернул ошибку
      console.error('API Error:', error.response.status, error.response.data)
    } else if (error.request) {
      // Запрос был отправлен, но ответа не получено
      console.error('Network Error:', error.request)
    } else {
      // Что-то пошло не так при настройке запроса
      console.error('Error:', error.message)
    }
    return Promise.reject(error)
  }
)

export default apiClient

// Типы для API ответов (будут расширены по мере необходимости)
export interface ApiResponse<T> {
  data: T
  message?: string
  status: number
}

export interface ApiError {
  message: string
  status: number
  errors?: Record<string, string[]>
}
